import { Link, useLocation } from 'react-router-dom';
import { LoginForm } from '../components/auth/LoginForm';
import { ROUTES } from '../utils/constants';
import { useTranslation } from 'react-i18next';

export function LoginPage() {
  const { t } = useTranslation('auth');
  const location = useLocation();
  const passwordResetSuccess = location.state?.passwordResetSuccess === true;

  return (
    <div className="min-h-screen flex items-center justify-center bg-neutral-50 py-12 px-4">
      <div className="max-w-md w-full">
        {passwordResetSuccess && (
          <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded text-green-700 text-sm text-center">
            {t('setNewPassword.successMessage')}
          </div>
        )}
        <div className="text-center mb-8">
          <Link to={ROUTES.HOME} className="inline-flex items-center gap-2 mb-6">
            <div className="w-10 h-10 bg-primary-700 rounded flex items-center justify-center">
              <span className="text-white font-bold text-xl">W</span>
            </div>
            <span className="text-2xl font-bold text-neutral-900">{t('common:appName')}</span>
          </Link>
          <h1 className="text-3xl font-bold text-neutral-900 mb-2">{t('login.title')}</h1>
          <p className="text-neutral-600">{t('login.subtitle')}</p>
        </div>

        <div className="bg-white p-8 rounded-lg shadow-sm border border-neutral-200">
          <LoginForm />
          <div className="mt-6 text-center text-sm text-neutral-600">
            <div>
              {t('login.noAccount')}{' '}
            </div>
            <div>
              <Link to={ROUTES.REGISTER} className="text-primary-700 hover:text-accent-600 font-medium">
                {t('login.signUp')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
